module.exports = __webpack_public_path__ + "static/media/add-img.9641bdde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add-img.svg
// module id = 837
// module chunks = 0